// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"528":"reports","594":"about"}[chunkId] || chunkId) + "." + {"91":"9e705d6f","528":"98678bb8","594":"db142ba1","631":"b543e459"}[chunkId] + ".js";
};